import { useEffect, useRef, useState } from 'react'

import { EVENT_NAME_RESIZE } from '../../../../constants/event'
import { toCSSPixel } from '../../../../utils/styles'

import {
  getPdfDocumentCoordinatesForSelectionBox,
  getSelectBoxStyleProperty,
  transformPercentCoordinatesToSelectAreaCoordinates,
  transformSelectAreaCoordinatesToPercentCoordinates,
} from './usePdfViewerSelectionAreaBox.utils'

export function usePdfViewerSelectionAreaBoxRect() {
  const selectBoxRef = useRef(null)
  const currentPageRef = useRef(null)
  const selectAreaLayerRef = useRef(null)
  const isInitSelectAreaRef = useRef(false)
  const percentCoordinatesRef = useRef(null)
  const pageRectRef = useRef(null)
  const gestureBoxRectRef = useRef(null)

  const [selectedBox, setSelectedBox] = useState(null)
  const [pdfPageCoordinates, setPdfPageCoordinates] = useState(null)

  function getCurrentPageRect() {
    return getPdfDocumentCoordinatesForSelectionBox({
      container: selectAreaLayerRef.current,
      page: currentPageRef.current,
    })
  }

  function setCoordinatesToSelectBoxStyle(coordinates) {
    if (selectBoxRef.current) {
      Object.entries(coordinates).forEach(([key, value]) => {
        selectBoxRef.current.style[getSelectBoxStyleProperty(key)] =
          toCSSPixel(value)
      })
    }
  }

  // a gesture writes the box straight to the dom, state is committed on mouseup
  function updateSelectBoxRect(rect) {
    gestureBoxRectRef.current = rect

    percentCoordinatesRef.current =
      transformSelectAreaCoordinatesToPercentCoordinates(
        rect,
        getCurrentPageRect()
      )

    setCoordinatesToSelectBoxStyle(rect)
  }

  function commitSelectBoxRect() {
    if (gestureBoxRectRef.current) {
      setSelectedBox(gestureBoxRectRef.current)

      gestureBoxRectRef.current = null
    }
  }

  function updateBoxFromRelativePdfCoordinates() {
    if (
      percentCoordinatesRef.current &&
      selectAreaLayerRef.current &&
      currentPageRef.current
    ) {
      const currentPageRect = getCurrentPageRect()
      const coordinates = transformPercentCoordinatesToSelectAreaCoordinates(
        percentCoordinatesRef.current,
        currentPageRect
      )

      pageRectRef.current = currentPageRect

      setPdfPageCoordinates(currentPageRect)
      setCoordinatesToSelectBoxStyle(coordinates)

      if (isInitSelectAreaRef.current) {
        setSelectedBox(coordinates)
      }
    }
  }

  useEffect(() => {
    window.addEventListener(
      EVENT_NAME_RESIZE,
      updateBoxFromRelativePdfCoordinates
    )

    return () => {
      window.removeEventListener(
        EVENT_NAME_RESIZE,
        updateBoxFromRelativePdfCoordinates
      )
    }
  }, [])

  return {
    commitSelectBoxRect,
    currentPageRef,
    getCurrentPageRect,
    isInitSelectAreaRef,
    pageRectRef,
    pdfPageCoordinates,
    percentCoordinatesRef,
    selectAreaLayerRef,
    selectBoxRef,
    selectedBox,
    setCoordinatesToSelectBoxStyle,
    setPdfPageCoordinates,
    setSelectedBox,
    updateBoxFromRelativePdfCoordinates,
    updateSelectBoxRect,
  }
}
